var React = require('react');
import Box from '@mui/material/Box';
/*
Calendar for browsing events and announcements
*/
const Calendar = () => {

    return (
        <Box sx={{ mt: 10 }}>
            <div>
                <h1>Calendar page</h1>
                <h1>under construction</h1>
            </div>
        </Box>
    );
};

export default Calendar;